const Lgpd = () => {

    const updated = '13/01/2025';
    const siteName = 'CPUWEB';
    const contact = 'atendimento@cpuweb.com.br';

    return (
        <div class="container pt-4 pb-4">
            <h1>Política de Privacidade e Termo de Consentimento</h1>
            <p><strong>Última atualização: {updated}</strong></p>

            <p>Bem-vindo(a) ao <strong>{siteName}</strong>. Para garantir a transparência sobre o uso de seus dados, explicamos abaixo como coletamos, usamos e protegemos suas informações, em conformidade com a <strong>Lei Geral de Proteção de Dados (LGPD) - Lei nº 13.709/2018</strong>.</p>

            <h2>1. Quais dados coletamos?</h2>
            <p>Ao utilizar nosso site, podemos coletar os seguintes dados:</p>
            <ul>
                <li><strong>Dados de cadastro:</strong> Nome, e-mail, telefone e cidade.</li>
                <li><strong>Dados de navegação:</strong> Endereço IP, tipo de navegador, páginas acessadas e tempo de permanência.</li>
                <li><strong>Dados de consulta:</strong> Histórico de pesquisa sobre insumos e materiais de construção.</li>
            </ul>

            <h2>2. Para que usamos seus dados?</h2>
            <p>Os dados coletados são utilizados para:</p>
            <ul>
                <li>Melhorar sua experiência no site, personalizando os resultados de consulta.</li>
                <li>Fornecer suporte técnico e atendimento ao usuário.</li>
                <li>Enviar comunicações, como promoções e novidades (se autorizado).</li>
                <li>Cumprir obrigações legais e regulatórias.</li>
            </ul>

            <h2>3. Compartilhamento de dados</h2>
            <p>Não vendemos seus dados. No entanto, podemos compartilhá-los com:</p>
            <ul>
                <li><strong>Fornecedores de tecnologia:</strong> Para hospedagem, segurança e análise de dados.</li>
                <li><strong>Parceiros comerciais:</strong> Para exibir ofertas e preços de insumos.</li>
                <li><strong>Órgãos reguladores:</strong> Se for exigido por lei.</li>
            </ul>

            <h2>4. Armazenamento e segurança</h2>
            <p>Seus dados são armazenados de forma segura e protegidos contra acessos não autorizados.</p>

            <h2>5. Seus direitos</h2>
            <p>Você pode, a qualquer momento:</p>
            <ul>
                <li>Acessar seus dados armazenados.</li>
                <li>Solicitar a correção de informações.</li>
                <li>Revogar seu consentimento.</li>
                <li>Excluir seus dados, salvo quando a retenção for obrigatória por lei.</li>
            </ul>

            <h2>6. Contato</h2>
            <p>Se tiver dúvidas ou desejar exercer seus direitos, entre em contato pelo e-mail: <strong>{contact}</strong>.</p>

            <h2>7. Atualizações da política</h2>
            <p>Este documento pode ser atualizado periodicamente. Recomendamos que consulte esta página regularmente.</p>

            <p class="footer">Ao continuar usando nosso site, você concorda com os termos descritos aqui.</p>
        </div>
    );
};

export default Lgpd;
